var map = {
	"./au.svg": 859,
	"./br.svg": 860,
	"./ca.svg": 861,
	"./cn.svg": 862,
	"./cz.svg": 863,
	"./de.svg": 864,
	"./dk.svg": 865,
	"./es.svg": 866,
	"./fi.svg": 867,
	"./fr.svg": 868,
	"./gb.svg": 869,
	"./hk.svg": 870,
	"./hu.svg": 871,
	"./id.svg": 872,
	"./it.svg": 873,
	"./jp.svg": 874,
	"./kr.svg": 875,
	"./mo.svg": 876,
	"./my.svg": 877,
	"./nl.svg": 878,
	"./no.svg": 879,
	"./pl.svg": 880,
	"./pt.svg": 881,
	"./ro.svg": 882,
	"./ru.svg": 883,
	"./sa.svg": 884,
	"./se.svg": 885,
	"./sk.svg": 886,
	"./th.svg": 887,
	"./tr.svg": 888,
	"./tw.svg": 889,
	"./us.svg": 890,
	"./vn.svg": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 858;